<template >
  <v-row justify="center">
    <v-dialog v-model="select.show" scrollable max-width="312px">
      <v-date-picker
        v-model="select.selectedItem"
        @click:date="selectItem(select.selectedItem)"
        :min="min"
        :max="max"
        :allowed-dates="allowedDates"
        :show-current="time.todayMoment.format('YYYY-MM-DD')"
        color="primary"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="closePopup">Cancel</v-btn>
      </v-date-picker>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "InputPopupSelectDate",
  props: {
    select: {
      show: Boolean,
      selectedItem: String,
    },
    min: String,
    max: String,
    allowedDates: Function,
  },
  methods: {
    closePopup() {
      this.$emit("update:select", {
        show: false,
        selectedItem: this.select.selectedItem,
      });
    },
    selectItem(item) {
      this.$emit("update:select", {
        show: false,
        selectedItem: item,
      });
    },
  },
};
</script>